import {Injectable} from '@angular/core';
import {buildNestedQuery} from '../query/elastic.queries';
import {ElasticParserFactory} from '../paser/factory.parsers';

@Injectable({
  providedIn: 'root'
})
export class ElasticFiltersService {
  constructor(private readonly elasticParserFactory: ElasticParserFactory) {
  }

  buildElasticDSLQueryBodyFromFilters(filters: any[], filtersMappingSearchProperties: any): any {
    const isFilterValid = (filter) => !filter.isInvalid;
    const isFilterEnable = (filter) => !filter.isDisabled;
    const isFilterValueParsedDefined = (filter) => (filter.valueParsed !== undefined && filter.valueParsed !== '');
    const isFilterMappingSearchPropertyDefined = (filter => !!filtersMappingSearchProperties[filter.id]);
    const isNotNestedPropertyFromFilter = (filter => !filtersMappingSearchProperties[filter.id]?.isNested);
    const parsedValueFromFilter = (filter) => {
      const filterProperty = filtersMappingSearchProperties[filter.id];
      const filterParser = this.elasticParserFactory.getElasticParser(filter.elasticParserType);

      return filterParser?.parseValue(filter.valueParsed, filterProperty);
    };
    const isNestedPropertyFromFilter = (filter => filtersMappingSearchProperties[filter.id]?.isNested);
    const parsedValueFromNestedFilter = (filter) => {
      const filterProperty = filtersMappingSearchProperties[filter.id];
      const filterParser = this.elasticParserFactory.getElasticParser(filter.elasticParserType);
      const filterValue = filter.valueParsed || filter.value;
      const parsedValued = filterParser?.parseValue(filterValue, filterProperty);

      return !!parsedValued ? buildNestedQuery(parsedValued, filterProperty.path) : undefined;
    };
    const parsedValueIsDefined = (parsedValue) => !!parsedValue;

    const filtersToBeParsed = filters.filter(isFilterValid)
      .filter(isFilterEnable)
      .filter(isFilterValueParsedDefined)
      .filter(isFilterMappingSearchPropertyDefined);

    const nestedParsedFilterQueries = filtersToBeParsed
      .filter(isNestedPropertyFromFilter)
      .map(parsedValueFromNestedFilter)
      .filter(parsedValueIsDefined);

    const parsedFilterQueries = filtersToBeParsed
      .filter(isNotNestedPropertyFromFilter)
      .map(parsedValueFromFilter)
      .filter(parsedValueIsDefined);

    return {
      bool:
        {
          must: [
            ...parsedFilterQueries,
            ...mergeNestedParsedFilterQueries(nestedParsedFilterQueries)
          ]
        }
    };
  }
}

const mergeNestedParsedFilterQueries = (nestedQueries: any[]): any[] => {
  nestedQueries.sort((a, b) => a.nested.path.localeCompare(b.nested.path));

  const mergedNestedQueries = [];
  for (const nestedQuery of nestedQueries) {
    const firstTokenNestedPath = nestedQuery.nested.path.split('\.')[0];
    const existingNestedQuery = mergedNestedQueries.find(query => query.nested.path === firstTokenNestedPath);

    if (existingNestedQuery) {
      if (existingNestedQuery.nested.path === nestedQuery.nested.path) {
        existingNestedQuery.nested.query.bool.must.push(...nestedQuery.nested.query.bool.must);
      } else {
        existingNestedQuery.nested.query.bool.must.push(nestedQuery);
      }
    } else {
      mergedNestedQueries.push(nestedQuery);
    }
  }

  return mergedNestedQueries;
};
